export interface ErrorJson {
    name?: string;
    message?: string;
    stack?: string;
    cause?: string;
    [key: string]: any;
}

export const errorToJson = (error: Error | undefined): ErrorJson =>
    error
        ? ({
              ...error,
              name: error.name,
              message: error.message,
              stack: error.stack,
              // eslint-disable-next-line typescript-compat/compat
              cause: error.cause ? error.cause.toString() : undefined,
          } as Object)
        : {};
